import React from "react"
import "../styles/global.css"

const Layout = ({ children }) => {
  return <div>{children}</div>
}

export default Layout
